import { styled } from "styled-components";


const ContentWrap = styled.div`
  width: 100%;
  height: 70vh;
  display: flex;
  flex-direction: column;

    & .body-content{
      flex: 1;
      overflow: auto;

      & .ant-tabs-content{
        height: 100%;
      }
      & .ant-tabs-tabpane{
        height: 100%;
      }
    }
`
export default ContentWrap;